const homepageFlickity = document.querySelector(".image-section__slider-wrapper");
const homepageHeroFlickity = document.querySelector(".js-homepage-hero-carousel");
const communityFlickity = document.querySelector(".gallery__slider");
// const aboutFlickity = document.querySelector(".collaborations__slider");
let flkty;
const newsFlickitys = document.querySelectorAll(".news-feature__image-carousel");
let flickity404 = document.querySelector(".js-404-carousel");

if (flickity404) {
    flkty = new Flickity(flickity404, {
        cellAlign: "left",
        contain: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        autoPlay: true,
        fade: true
    });
}

if (homepageHeroFlickity) {
    flkty = new Flickity(homepageHeroFlickity, {
        cellAlign: "left",
        contain: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        autoPlay: true,
        fade: true
    });
}


if (homepageFlickity) {
    flkty = new Flickity(homepageFlickity, {
        cellAlign: "left",
        contain: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        cellSelector: ".carousel-cell"
    });

    flkty.on('dragStart', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "none") );
    flkty.on('dragEnd', () => flkty.slider.childNodes.forEach(slide => slide.style.pointerEvents = "all") );

    const projPrev = document.querySelector(".js-project-prev"),
        projext = document.querySelector(".js-project-next");

    projPrev.addEventListener("click", () => {
        flkty.previous();
    });

    projext.addEventListener("click", () => {
        flkty.next();
    });

}

if (communityFlickity) {
    flkty = new Flickity(communityFlickity, {
        cellAlign: "left",
        //contain: true,
        draggable: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        imagesLoaded: true,
        resize: true,
        lazyLoad: 3
    });

    const commSliderParent = document.querySelector(".js-gallery-slider-parent"),
        commSliderNav = document.querySelector(".js-gallery-slider-nav"),
        commNavPrev = document.querySelector(".js-gallery-prev"),
        commNavNext = document.querySelector(".js-gallery-next");

    //prev
    commNavPrev.addEventListener("click", () => {
        flkty.previous();
    });
    // next
    commNavNext.addEventListener("click", () => {
        flkty.next();
    });

    commSliderParent.addEventListener("mouseenter", () => {
        commSliderNav.classList.add("active");
    });

    commSliderParent.addEventListener("mouseleave", () => {
        commSliderNav.classList.remove("active");
    });
}

// if (aboutFlickity) {
//     flkty = new Flickity(aboutFlickity, {
//         cellAlign: "center",
//         contain: true,
//         draggable: true,
//         wrapAround: true,
//         prevNextButtons: false,
//         pageDots: false,
//         imagesLoaded: true,
//     });
// }

if (newsFlickitys) {
    newsFlickitys.forEach((slider) => {
        const flkty = new Flickity(slider, {
            cellAlign: "left",
            contain: true,
            draggable: true,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            imagesLoaded: true,
            cellSelector: ".news-feature__image-carousel-slide"
        });

        const carouselStatus = slider.querySelector('.news-feature__carousel-status');

        flkty.on("select", function() {
            var slideNumber = flkty.selectedIndex + 1;
            carouselStatus.textContent = slideNumber + "/" + flkty.slides.length;
        });
    });
}
